import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@b/layout'

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [

  {
    hidden: true,
    path: '/login',
    component: () => import('@b/views/login/index'),
    meta: { title:'登入' },
  },
  
  {
    path:'/',
    component: Layout, 
    redirect: '/',
    name: 'icare3+1',
    meta: { title:'icare3+1', icon: 'fa-tachometer-alt' },
    children: [{
      path: '/',
      name: '首頁',
      component: () => import('@b/views/dashboard/index'),
      meta: { title:'首頁' },
    }]
  },
  {
    path:'/info',   
    component: Layout,
    redirect: '/info/info',
    name: '管理員',
    meta: { title:'管理員', icon: 'fa-home' },
    children: [{
      path: '/info',
      name: '個人資料',
      component: () => import('@b/views/admin/admin_profile'),
      meta: { title:'個人資料' },
    }]
  },
  {
    path:'/admin',
    component: Layout,
    redirect: '/admin/admin',
    name: '系統',
    meta: { title:'系統', icon: 'fa-desktop' },
    children: [
      {
        path: '/admin/admin',
        name: '帳號',
        component: () => import('@b/views/admin/admin'),
        meta: { title:'帳號' },
      },
      {
        path: '/admin/role',
        name: '角色',
        component: () => import('@b/views/admin/admin_roles'),
        meta: { title:'角色' },
      },
      {
        path: '/admin/com',
        name: '公司',
        component: () => import('@b/views/com/com'),
        meta: { title:'公司' },
      }
    ]
  },
  {
    path:'/line',   
    component: Layout,
    redirect: '/line/pushText',
    name: '推播設定',
    meta: { title:'推播設定', icon: 'fa-home' },
    children: [
      {
        path: '/line/temp',
        name: '新增卡片',
        component: () => import('@b/views/line/template'),
        meta: { title:'新增卡片' },
      },
      {
        path: '/line/template_list',
        name: '卡片清單',
        component: () => import('@b/views/line/template_list'),
        meta: { title:'卡片清單' },
      },
      {
        path: '/line/material',
        name: '推播素材',
        component: () => import('@b/views/line/material'),
        meta: { title:'推播素材' },
      },
      {
        path: '/line/material/set',
        name: '推播素材套餐',
        component: () => import('@b/views/line/material_set'),
        meta: { title:'推播素材套餐' },
      },
      {
        path: '/line/keyworld',
        name: '關鍵字推播',
        component: () => import('@b/views/line/keyworld'),
        meta: { title:'關鍵字推播' },
      },
      {
        path: '/line/push',
        name: '推播',
        component: () => import('@b/views/line/push'),
        meta: { title:'推播' },
      },
    ]
  },
  {
    hidden: true,
    path:'/template',   
    component: Layout,
    redirect: '/line/pushText',
    name: '卡片設定',
    meta: { title:'卡片設定', icon: 'fa-home' },
    children: [
      {
        path: '/template/edit',
        component: () => import('@b/views/line/template'),
        meta: { title:'卡片編輯' },
      },
    ]
  },
  
]

const createRouter = () => new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
